module.exports = "<tree-diagram (drop)=\"dropNode($event)\" [data]=\"treeData\"></tree-diagram>"